// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SidebarItem-module-sidebarItem > a {
  opacity: 0.7;
  border-radius: 5px;
  width: 40px;
  height: 40px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
}

.SidebarItem-module-sidebarItem.SidebarItem-module-selected > a {
  color: var(--primary);
  opacity: 1;
}

.SidebarItem-module-sidebarItem.SidebarItem-module-selected > a > svg {
  fill: var(--primary);
}

.SidebarItem-module-sidebarItem > a:hover {
  opacity: 1;
}

.SidebarItem-module-sidebarItem > a:hover:active {
  transform: scale(0.95);
}

.SidebarItem-module-sidebarItem > a > svg {
  width: 20px;
  height: 20px;
  fill: var(--text);
}

.SidebarItem-module-label {
  display: none;
}

.sidebar-open .SidebarItem-module-sidebarItem > a {
  justify-content: left;
  height: initial;
  width: initial;
  padding: 10px 15px;
}

.sidebar-open .SidebarItem-module-label {
  display: inline;
}`, "",{"version":3,"sources":["webpack://./src/Router/App/components/SidebarItem/SidebarItem.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB","sourcesContent":[".sidebarItem > a {\r\n  opacity: 0.7;\r\n  border-radius: 5px;\r\n  width: 40px;\r\n  height: 40px;\r\n  box-sizing: border-box;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  padding: 0;\r\n}\r\n\r\n.sidebarItem.selected > a {\r\n  color: var(--primary);\r\n  opacity: 1;\r\n}\r\n\r\n.sidebarItem.selected > a > svg {\r\n  fill: var(--primary);\r\n}\r\n\r\n.sidebarItem > a:hover {\r\n  opacity: 1;\r\n}\r\n\r\n.sidebarItem > a:hover:active {\r\n  transform: scale(0.95);\r\n}\r\n\r\n.sidebarItem > a > svg {\r\n  width: 20px;\r\n  height: 20px;\r\n  fill: var(--text);\r\n}\r\n\r\n.label {\r\n  display: none;\r\n}\r\n\r\n:global(.sidebar-open) .sidebarItem > a {\r\n  justify-content: left;\r\n  height: initial;\r\n  width: initial;\r\n  padding: 10px 15px;\r\n}\r\n\r\n:global(.sidebar-open) .label {\r\n  display: inline;\r\n}"],"sourceRoot":""}]);
// Exports
export var sidebarItem = `SidebarItem-module-sidebarItem`;
export var selected = `SidebarItem-module-selected`;
export var label = `SidebarItem-module-label`;
export default ___CSS_LOADER_EXPORT___;
